import React from 'react';
import NProgress from 'nprogress';
import Router from 'next/router';
import Head from 'next/head';
import { NextComponentType } from 'next';
import { AppProps } from 'next/app';
import { ApolloProvider } from '@apollo/client';
import { SessionProvider } from 'next-auth/react';
import {
  CompanybrandingContextProvider,
  ShopCartContextProvider,
  ThemeContextProvider,
  ToastContextProvider,
  UserContextProvider,
} from '../context';
import { useApollo } from '../hooks';
import '../style.css';
import Auth from '../components/AuthSession/Auth';
import { PaymentProcessProvider } from '../context/PaymentProcessContext';

type CustomAppProps = AppProps & {
  Component: NextComponentType & { auth?: boolean }; // add auth type to protect routes
};

// @ts-expect-error err is not defined
function MyApp({ Component, pageProps, err }: CustomAppProps<any>) {
  const apolloClient = useApollo(pageProps.initialApolloState);
  React.useEffect(() => {
    Router.events.on('routeChangeStart', () => {
      NProgress.start();
    });

    Router.events.on('routeChangeComplete', () => {
      NProgress.done();
    });

    Router.events.on('routeChangeError', () => {
      NProgress.done();
    });
  }, []);
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      // On page load or when changing themes, best to add inline in `head` to avoid FOUC
      if (
        localStorage.theme === 'dark' ||
        (!('theme' in localStorage) &&
          window.matchMedia('(prefers-color-scheme: dark)').matches)
      ) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }

      // Whenever the user explicitly chooses light mode
      localStorage.theme = 'light';

      // Whenever the user explicitly chooses dark mode
      localStorage.theme = 'dark';

      // Whenever the user explicitly chooses to respect the OS preference
      localStorage.removeItem('theme');
    }
  }, []);
  return (
    <SessionProvider session={pageProps.session} refetchInterval={0}>
      <ApolloProvider client={apolloClient}>
        <>
          <Head>
            <title>Meit!</title>
          </Head>
          <meta
            name="description"
            content="Sistematizamos los planes de beneficios e incentivos de tu empresa."
          />
          <ThemeContextProvider>
            <CompanybrandingContextProvider>
              <ToastContextProvider>
                {Component?.auth ? (
                  <Auth>
                    <UserContextProvider>
                      <ShopCartContextProvider>
                        <PaymentProcessProvider>
                          <Component {...pageProps} err={err} />
                        </PaymentProcessProvider>
                      </ShopCartContextProvider>
                    </UserContextProvider>
                  </Auth>
                ) : (
                  <Component {...pageProps} />
                )}
              </ToastContextProvider>
            </CompanybrandingContextProvider>
          </ThemeContextProvider>
        </>
      </ApolloProvider>
    </SessionProvider>
  );
}

export default MyApp;
